/* eslint-disable import/prefer-default-export */

/**
 * Contains keys for accessing various values in localStorage
 */

// TRUS_POSTPONE_UW_KEY:
// a map of application IDs for apps that have had their "begin underwriting" prompt dismissed
export const TRUS_POSTPONE_UW_KEY = "TRUSDismissedUnderwritingApplications";
